/**
 * Retorno sonoro da leitura.
 *
 * Oscilador em vez de arquivo de áudio: não há asset para carregar, cachear ou
 * versionar, e o caixa precisa distinguir sucesso de erro sem olhar a tela.
 */

let contexto: AudioContext | null = null;

function obterContexto(): AudioContext | null {
  if (typeof window === 'undefined') return null;

  try {
    const Ctor =
      window.AudioContext ??
      (window as unknown as { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;
    if (!Ctor) return null;

    contexto ??= new Ctor();
    return contexto;
  } catch {
    return null;
  }
}

function tocar(frequencia: number, duracaoMs: number): void {
  const ctx = obterContexto();
  if (!ctx) return;

  try {
    // Navegadores suspendem o contexto até um gesto do usuário; abrir o
    // leitor já é um gesto, então retomar aqui é suficiente.
    void ctx.resume();

    const oscilador = ctx.createOscillator();
    const ganho = ctx.createGain();

    oscilador.type = 'sine';
    oscilador.frequency.value = frequencia;
    ganho.gain.setValueAtTime(0.08, ctx.currentTime);
    ganho.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + duracaoMs / 1000);

    oscilador.connect(ganho).connect(ctx.destination);
    oscilador.start();
    oscilador.stop(ctx.currentTime + duracaoMs / 1000);
  } catch {
    // Som é conveniência; a tela já mostra o resultado da leitura.
  }
}

/** Agudo e curto: peça entrou no carrinho. */
export const bipeSucesso = () => tocar(1046, 120);

/** Grave e mais longo: leitura recusada. */
export const bipeErro = () => tocar(220, 260);
